export default {
  fixedAssetsApi: {
    fixedAssetsManager: {
      getSourceOptions: '/api/fixedAssetsApi/getSourceOptions',
      getStatusOptions: '/api/fixedAssetsApi/getStatusOptions',
      getList: '/api/fixedAssetsApi/getList',
      save: '/api/fixedAssetsApi/save',
      update: '/api/fixedAssetsApi/update',
      del: '/api/fixedAssetsApi/del',
    }
  }
}
